// From https://github.com/straxico/use-detect-keyboard-open

import React from 'react'

const useDetectKeyboardOpen = (minKeyboardHeight = 300) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = React.useState(false)

  React.useEffect(() => {
    const listener = () => {
      const newState =
        window.screen.height - minKeyboardHeight > window.visualViewport.height
      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState)
      }
    }

    if (typeof visualViewport != 'undefined') {
      window.visualViewport.addEventListener('resize', listener)
    }

    return () => {
      if (typeof visualViewport != 'undefined') {
        window.visualViewport.removeEventListener('resize', listener)
      }
    }
  }, [isKeyboardOpen, minKeyboardHeight])

  return isKeyboardOpen
}

export default useDetectKeyboardOpen
